import { t } from 'i18next';
import { ApiResponseError } from '../../types/errors';
import type { WrappedNotificationHandlerContract } from '../../types/handlers/notification';

export function handleCustomerGroupTableDeleteError(
  err: unknown,
  notificationHandler: WrappedNotificationHandlerContract,
  name: string,
) {
  if (ApiResponseError.isApiResponseError(err, ApiResponseError.errorSchemas.errors)) {
    const errCode = err.data.errors[0]?.code;
    if (err.status === 400 && errCode === 'resource-in-use') {
      notificationHandler.error(
        t(
          'features:customer_group.components.delete_customer_group_modal.status.errors.resource_in_use',
          { name },
        ),
      );
      return;
    }
  }
  notificationHandler.error(
    t(`features:customer_group.components.delete_customer_group_modal.status.errors.delete_failed`),
  );
}

export function handleCustomerGroupBuilderAxiosError(
  err: unknown,
  notificationHandler: WrappedNotificationHandlerContract,
  updating: boolean,
) {
  if (ApiResponseError.isApiResponseError(err, ApiResponseError.errorSchemas.errors)) {
    const errCode = err.data.errors[0]?.code;
    if (err.status === 400 && errCode === 'resource-already-exists') {
      notificationHandler.error(
        t(
          'features:customer_group.pages.customer_group_builder_page.notifications.errors.no_unique_id',
        ),
      );
    } else if (err.status === 400 && errCode === 'keyword-mismatch') {
      notificationHandler.error(
        t(
          'features:customer_group.pages.customer_group_builder_page.notifications.errors.invalid_char',
        ),
      );
    } else if (err.status === 400 && errCode === 'invalid-param') {
      notificationHandler.error(
        t(
          'features:customer_group.pages.customer_group_builder_page.notifications.errors.invalid_id',
        ),
      );
    } else {
      notificationHandler.error(
        t(
          `features:customer_group.pages.customer_group_builder_page.notifications.errors.${updating ? 'update' : 'create'}_failed`,
        ),
      );
    }
    return;
  }
  notificationHandler.error(
    t(
      `features:customer_group.pages.customer_group_builder_page.notifications.errors.${updating ? 'update' : 'create'}_failed`,
    ),
  );
}
